import React from 'react';
import Box, { type BoxProps } from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { subtleScrollbarSx, type ScrollbarVariant } from '../../../styles/theme/scrollbar';

export type ScrollableAxis = 'y' | 'x' | 'both';

export interface ScrollableBoxProps extends BoxProps {
  /** Variante visual de la barra de desplazamiento */
  variant?: ScrollbarVariant;
  /** Eje de scroll habilitado */
  axis?: ScrollableAxis;
  /** Reserva espacio para la barra y evita saltos de layout */
  stableGutter?: boolean;
}

const overflowByAxis: Record<ScrollableAxis, BoxProps['sx']> = {
  y: { overflowY: 'auto', overflowX: 'hidden' },
  x: { overflowX: 'auto', overflowY: 'hidden' },
  both: { overflow: 'auto' },
};

export const ScrollableBox = React.forwardRef<HTMLDivElement, ScrollableBoxProps>(
  ({ variant = 'default', axis = 'y', stableGutter = false, sx, ...props }, ref) => {
    const theme = useTheme();

    return (
      <Box
        ref={ref}
        sx={[
          overflowByAxis[axis],
          stableGutter && { scrollbarGutter: 'stable' },
          subtleScrollbarSx(theme, variant),
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
        {...props}
      />
    );
  },
);

ScrollableBox.displayName = 'ScrollableBox';
